<template>
  <div class="analysis">
    <div class="navs">
      <a href="javascript:void(0);" :class="{ cur: mType == 0 }" @click="ck(0)">新增债务人统计</a>
      <a href="javascript:void(0);" :class="{ cur: mType == 1 }" @click="ck(1)">新增案件统计</a>
      <a href="javascript:void(0);" :class="{ cur: mType == 2 }" @click="ck(2)">新增进度统计</a>
    </div>
    <div class="top wbg" v-if="$common.AUTH('statis:addCount:lists')">
      <div class="find" v-if="mType == 2">
        <a-row class="row" :gutter="40">
          <a-col :span="6" class="flex">
            <label>案件类型：</label>
            <a-select v-model="form.cause_type" placeholder="请选择" class="select" allowClear>
              <!-- <a-select-option :value="0" disabled>调解</a-select-option> -->
              <a-select-option :value="2">调解</a-select-option>
              <a-select-option :value="1">诉讼</a-select-option>
              <a-select-option :value="3" disabled>公证执行</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6" class="flex">
            <label>原告：</label>
            <a-select class="select" v-model="form.accuser_id" placeholder="请选择" mode="multiple" :maxTagCount="1"
              :maxTagTextLength="12" allowClear :filter-option="$common.filterOption">
              <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
              }}</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6" class="flex">
            <label>新增时间：</label>
            <timePick :now="nowTime" @PickTime="PickTime" ref="timePicker"></timePick>
          </a-col>
          <a-col :span="6" class="flex">
            <a-button icon="search" type="primary" style="height: 30px; margin-right: 20px"
              @click="search">查询</a-button>
            <a-button style="height: 32px; margin: 0 10px 0 0" @click="reset(2)">重置</a-button>
          </a-col>
        </a-row>
      </div>
      <div class="find" v-if="mType == 1">
        <a-row class="row" :gutter="40">
          <a-col :span="6" class="flex">
            <label>委托类型：</label>
            <a-select placeholder="请选择" class="select" v-model="form.case">
              <a-select-option :value="1">委托代理</a-select-option>
              <a-select-option :value="2">委托管理</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6" class="flex">
            <label>案件类型：</label>
            <a-select v-model="form.cause_type" placeholder="请选择" class="select" allowClear>
              <!-- <a-select-option :value="0" disabled>调解</a-select-option> -->
              <a-select-option :value="2">调解</a-select-option>
              <a-select-option :value="1">诉讼</a-select-option>
              <a-select-option :value="3" disabled>公证执行</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6" class="flex">
            <label>原告：</label>
            <a-select class="select" v-model="form.accuser_id" placeholder="请选择" mode="multiple" :maxTagCount="1"
              :maxTagTextLength="12" allowClear :filter-option="$common.filterOption">
              <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
              }}</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="6" class="flex">
            <label>管辖法院：</label>
            <a-select class="select" v-model="form.court_id" placeholder="请选择" mode="multiple" :maxTagCount="1"
              :maxTagTextLength="14" @search="handleSearch" :default-active-first-option="false" :show-arrow="false"
              :filter-option="false" :not-found-content="null" allowClear>
              <a-select-option v-for="item in courtList" :key="item.title" :value="item.id">{{ item.title
              }}</a-select-option>
            </a-select>
          </a-col>
        </a-row>
        <a-row :gutter="40">
          <a-col :span="6" class="flex">
            <label>新增时间：</label>
            <timePick :now="nowTime" @PickTime="PickTime" ref="timePicker"></timePick>
          </a-col>
          <a-col :span="6" class="flex">
            <a-button icon="search" type="primary" style="height: 30px; margin-right: 20px"
              @click="search">查询</a-button>
            <a-button style="height: 32px; margin: 0 10px 0 0" @click="reset(1)">重置</a-button>
          </a-col>
        </a-row>
      </div>
      <div class="find" v-if="mType == 0">
        <a-row class="row">
          <a-col :span="8" class="flex">
            <label>关联原告：</label>
            <a-select class="select" v-model="form.accuser_id" placeholder="请选择" mode="multiple" :maxTagCount="1"
              :maxTagTextLength="12" allowClear :filter-option="$common.filterOption">
              <a-select-option v-for="item in accuserList" :key="item.title" :value="item.id">{{ item.title
              }}</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="8" class="flex">
            <label>新增时间：</label>
            <timePick :now="nowTime" @PickTime="PickTime" ref="timePicker"></timePick>
          </a-col>
          <a-col :span="4" class="flex">
            <a-button icon="search" type="primary" style="height: 32px; margin-right: 20px"
              @click="search">查询</a-button>
            <a-button style="height: 32px; margin: 0 10px 0 0" @click="reset(0)">重置</a-button>
          </a-col>
        </a-row>
      </div>
    </div>
    <div class="conmains" v-if="mType == 0">
      <div class="lbo">
        <div class="item">
          <i class="icon i2"></i>
          <div class="htit">新增债务人</div>
          <div class="nums">{{ static.newDebtorData.debtor_count || 0 }}个</div>
        </div>
        <div class="item">
          <i class="icon i3"></i>
          <div class="htit">同期新增案件</div>
          <div class="nums">{{ static.newDebtorData.cause_count || 0 }}个</div>
        </div>
        <div class="item">
          <i class="icon i1"></i>
          <div class="htit">同期新增进度</div>
          <div class="nums">{{ static.newDebtorData.step_count || 0 }}个</div>
        </div>
      </div>
      <div class="rbo">
        <!-- <Chart id="id1" title="男女比例" :data="data1"></Chart>
        <Chart id="id2" title="新增占比" :data="data2"></Chart>
        <Chart id="id3" title="代偿情况" :data="data3"></Chart> -->
        <img src="@/assets/img/sk1.png" />
      </div>
    </div>
    <div class="conmains" v-if="mType == 1">
      <div class="lbo nbo">
        <div class="item">
          <i class="icon i3"></i>
          <div class="htit">新增案件数</div>
          <div class="nums">
            {{ static.newCauseData.new_count.cause_count || 0 }}个
          </div>
        </div>
        <div class="item">
          <i class="icon i2"></i>
          <div class="htit">关联债务人</div>
          <div class="nums">
            {{ static.newCauseData.new_count.debtor_count || 0 }}个
          </div>
        </div>
        <div class="item">
          <i class="icon i1"></i>
          <div class="htit">同期新增进度</div>
          <div class="nums">
            {{ static.newCauseData.new_count.step_count || 0 }}个
          </div>
        </div>
        <div class="item">
          <i class="icon i4"></i>
          <div class="htit">涉案本金</div>
          <div class="nums">
            {{ static.newCauseData.new_count.capital | showYuan }} 元
          </div>
        </div>
      </div>
      <div class="rbo">
        <img src="@/assets/img/sk2.png" />
      </div>
    </div>
    <div class="conmains" v-if="mType == 2">
      <div class="lf">
        <i class="icon i1"></i>
        <div class="htit">新增进度</div>
        <div class="nums">{{ StepList.count }}个</div>
      </div>
      <div class="rt" :class="{ nrt: StepList.length <= 16 }">
        <div class="li" v-for="i in StepList.list" @click="setpCk(i)" :class="{ cur: step == i.lite }">
          <div class="tit">{{ i.name }}</div>
          <div class="nums">{{ i.total }}</div>
        </div>
      </div>
    </div>

    <div class="botmains">
      <div class="h2">
        {{
          mType == 0
            ? "新增债务人概况"
            : mType == 1
              ? "新增案件概况"
              : "新增进度概况"
        }}
      </div>
      <div class="tableList" v-if="$common.AUTH('statis:addCount:lists')">
        <div class="table" v-if="mType == 0">
          <table>
            <thead>
              <td width="62">债务人</td>
              <td width="120">债务人证件号码</td>
              <td width="120">关联原告</td>
              <td width="180">户籍所在地</td>
              <td width="100">所属案件</td>
              <td width="120">当前进度</td>
              <td width="148" style="padding-left: 30px">录入时间</td>
            </thead>
            <tbody>
              <tr v-for="(i, index) in data" :key="index">
                <td>
                  <span class="curpoter" @click="dbclick(i)">
                    {{ i.realname }}</span>
                </td>
                <td>{{ i.chinaid }}</td>
                <td>
                  <Normap :tit="i.accuser ? i.accuser.title : '/'"></Normap>
                </td>
                <td>
                  <Normap :tit="i.province ? i.province + i.city + i.area + i.addr : '/'
                    "></Normap>
                </td>
                <td>
                  <p v-for="(j, index) in i.cause" :key="index">案件{{ j.sort }}</p>
                  <span v-if="i.cause.length == 0">/</span>
                </td>
                <td>
                  <p v-for="(j, index) in i.cause" :key="index">
                    {{ j.step.length ? j.step[0].title : "/" }}
                  </p>
                  <span v-if="i.cause.length == 0">/</span>
                </td>
                <td>
                  <p v-for="(j, index) in i.cause" :key="index" style="padding-left: 30px">
                    {{ j.create_time }}
                  </p>
                  <span v-if="i.cause.length == 0" style="padding-left: 30px">/</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="table" v-else>
          <table>
            <thead>
              <td width="62">债务人</td>
              <td width="110">债务人证件号码</td>
              <td width="140">原告</td>
              <td width="220">管辖法院</td>
              <td width="80">所属案件</td>
              <td width="100">{{ mType == 2 ? "新增进度" : "当前进度" }}</td>
              <td width="120">案号</td>
              <td width="148" style="padding-left: 30px">新增日期</td>
            </thead>
            <tbody>
              <tr v-for="(i, index) in data" :key="index">
                <td>
                  <span class="curpoter" @click="dbclick(i)">
                    {{ i.realname }}</span>
                </td>
                <td>{{ i.chinaid }}</td>
                <td>
                  <p v-for="(j, index) in i.cause" :key="index">
                    <Normap :tit="j.accuser ? j.accuser.title : '/'"></Normap>
                  </p>
                </td>
                <td>
                  <p v-for="(j, index) in i.cause" :key="index">
                    <Normap :tit="j.court">{{ j.court }}</Normap>
                  </p>
                </td>
                <td>
                  <p v-for="(j, index) in i.cause" :key="index">案件 {{ j.sort }}</p>
                  <span v-if="i.cause.length == 0">/</span>
                </td>
                <td>
                  <p v-for="(j, index) in i.cause" :key="index">
                    {{ j.step.length ? j.step[0].title : "/" }}
                  </p>
                  <span v-if="i.cause.length == 0">/</span>
                </td>
                <td>
                  <p v-for="(j, index) in i.cause" :key="index">
                    <Normap :tit="j.no">{{ j.no }}</Normap>
                  </p>
                  <span v-if="i.cause.length == 0">/</span>
                </td>
                <td>
                  <p v-for="(j, index) in i.cause" :key="index" style="padding-left: 30px">
                    <span v-if="mType == 2">{{
                      j.step.length ? j.step[0].create_time : "/"
                    }}</span>
                    <span v-else>{{ j.create_time }}</span>
                  </p>
                  <span v-if="i.cause.length == 0" style="padding-left: 30px">/</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="pages">
          <a-pagination v-model="page" show-quick-jumper :total="total" show-less-items :pageSize="10"
            @change="turnpage" :show-total="(total) => `小计：${total} `" />
        </div>
      </div>
      <div class="nqx" v-else>您没有该页面的访问权限，请联系管理员开通。</div>
    </div>
  </div>
</template>
<script>
import { getAccuserAll } from "@/server/api";
import { getDirectory } from "@/server/directory";
import {
  newDebtorData,
  newDebtorDataList,
  newCauseData,
  newCauseDataList,
  newStepData,
  newStepDataList,
} from "@/server/debtor";
import Step from "../ly/step.json"; //进度json
import artStep from "../ly/artStep.json"; //进度json
import { dateFormat } from "@/assets/js/formData";
import Chart from "./echarts/chart.vue";
export default {
  components: {
    Chart,
  },
  data() {
    return {
      data1: [
        { value: 1048, name: "男" },
        { value: 735, name: "女" },
      ],
      data2: [
        { value: 10, name: "今日新增" },
        { value: 280, name: "本月新增" },
      ],
      data3: [
        { value: 735, name: "不祥" },
        { value: 1048, name: "代偿完毕" },
        { value: 735, name: "未代偿" }
      ],
      static: {
        step_group: [],
        newCauseData: {
          new_count: {},
        },
        newDebtorData: {},
      },
      StepList: {
        list: [],
        count: 0,
      },
      step: null,
      time: {},
      mType: 0,
      courtList: [], //法院
      accuserList: [],
      form: {
        case: 1,
        cause_type: undefined,
        court_id: [],
        accuser_id: [],
      },
      page: 1,
      data: [],
      total: 0,
      nowTime: "",
    };
  },
  created() {
    //默认当天时间
    let now = dateFormat(new Date()).slice(0, 10);
    this.nowTime = now;
    getAccuserAll().then((res) => {
      this.accuserList = res.list;
    });

    this.ck(0);
  },
  methods: {
    dbclick(record) {
      if (this.$common.AUTH("debtor:info")) {
        let routeUrl = this.$router.resolve({
          name: "lydetails",
          params: {
            id: record.id,
          },
        });
        window.open(routeUrl.href, "_blank");
      } else {
        this.$message.error({
          content: "暂无权限",
          key: "updatable",
        });
      }
    },
    ck(type) {
      this.step = null;
      this.mType = type;
      this.form.accuser_id = [];
      this.form.court_id = [];
      this.step = null;
      let now = dateFormat(new Date()).slice(0, 10);
      this.time.stime = now;
      this.time.etime = now;
      if (type == 2) {
        this.step = 3;
        this.form.cause_type = undefined;
      } else {
        this.form.cause_type = undefined;
      }
      this.search();
    },
    setpCk(i) {
      // this.step=this.step===i.lite?null:i.lite
      this.step = i.lite;
      this.page = 1;
      this.getList(false);
    },
    stepJSON(data) {
      const stepJSON = this.form.cause_type == 1 ? Step : artStep;
      let StepList = [];
      for (let val in stepJSON) {
        StepList = StepList.concat(stepJSON[val]);
      }
      StepList = StepList.filter((ele) => {
        return ele.lite != "181";
      });
      StepList.map((ele) => {
        ele.total = 0;
        data.map((s) => {
          if (ele.lite == s.step) {
            ele.total = s.counts;
          }
        });
      });
      return StepList;
    },
    getList(isList) {
      const form = JSON.parse(JSON.stringify(this.form));
      let nForm = {};
      nForm.start_date = this.time.stime;
      nForm.end_date = this.time.etime;
      if (this.mType == 0) {
        nForm.accuser_id = form.accuser_id.toString();
        if (isList) {
          newDebtorData(nForm).then((e) => {
            this.static.newDebtorData = e;
          });
        }
        newDebtorDataList(
          Object.assign({ page: this.page, limit: 10 }, nForm)
        ).then((e) => {
          this.data = e.list;
          this.total = e.count;
        });
      } else if (this.mType == 1) {
        nForm.accuser_id = form.accuser_id.toString();
        nForm.cause_type = form.cause_type;
        nForm.court_id = form.court_id.toString();
        if (isList) {
          newCauseData(nForm).then((e) => {
            this.static.newCauseData = e;
          });
        }
        newCauseDataList(
          Object.assign({ page: this.page, limit: 10 }, nForm)
        ).then((e) => {
          this.data = e.list;
          this.total = e.count;
        });
      } else {
        nForm.accuser_id = form.accuser_id.toString();
        nForm.cause_type = form.cause_type;
        if (isList) {
          newStepData(nForm).then((e) => {
            // console.log(e);
            this.StepList = {
              count: e.count,
              list: this.stepJSON(e.list),
            };
          });
        }
        newStepDataList(
          Object.assign({ page: this.page, limit: 10, step: this.step }, nForm)
        ).then((e) => {
          this.data = e.list;
          this.total = e.count;
        });
      }
    },
    search() {
      this.page = 1;
      this.getList(true);
    },
    reset(e) {
      if (e == 0) {
      } else if (e == 1) {
        this.form.case = "";
        this.form.cause_type = undefined;
        this.form.court_id = [];
      } else {
        this.form.cause_type = undefined;
      }
      this.form.limit = 10
      this.form.page = 1
      this.time.stime = "";
      this.time.etime = "";
      this.form.accuser_id = [];
      this.$refs.timePicker.clearTime();
      this.search();
    },
    turnpage(val) {
      this.page = val;
      this.getList(false);
    },
    PickTime(e) {
      if ("stime" in e) {
        this.time.stime = e.stime;
      } else {
        this.time.etime = e.etime;
      }
      // const keys = {
      //   1: {
      //     stime: 'debtor_start_date',
      //     etime: 'debtor_end_date'
      //   },
      //   2: {
      //     stime: 'cause_start_date',
      //     etime: 'cause_end_date'
      //   },
      //   3: {
      //     stime: 'step_start_date',
      //     etime: 'step_end_date'
      //   }
      // }
      // if ("stime" in e) {
      //   this.time[keys[type].stime] = e.stime
      // } else {
      //   this.time[keys[type].etime] = e.etime
      // }
    },
    handleSearch(val) {
      getDirectory({
        limit: 100,
        title: val,
      }).then((res) => {
        this.courtList = res.list;
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import url("@/assets/css/search.less");

.navs {
  display: flex;
  height: 50px;
  padding-top: 20px;
  line-height: 22px;
  background: #fff;
  border-bottom: 1px solid #ddd;
  padding-left: 20px;

  a {
    display: block;
    padding-bottom: 10px;
    font-size: 16px;
    font-weight: normal;
    color: #333333;
    border-bottom: 4px solid transparent;
    margin-right: 30px;
    margin-bottom: -1px;
  }

  .cur {
    color: #1d8bfe;
    border-color: #1d8bfe;
  }
}

.h2 {
  line-height: 62px;
  padding-left: 20px;
  font-size: 16px;
  color: #0e2949;
  font-weight: bold;
  border-bottom: 1px solid #efefef;
}

.conmains {
  background: #fff;
  margin-bottom: 10px;
  padding: 0 20px 20px;
  display: flex;

  .icon {
    width: 36px;
    height: 36px;
    background-repeat: no-repeat;
    display: block;
    background-position: center;
  }

  .i1 {
    background-image: url("../../assets/img/icon-jindu.png");
    background-size: 14px 18px;
  }

  .i2 {
    background-image: url("../../assets/img/icon-zhaiwuren.png");
    background-size: 18px 18px;
  }

  .i3 {
    background-image: url("../../assets/img/icon-anjian.png");
    background-size: 17px 17px;
  }

  .i4 {
    background-image: url("../../assets/img/icon-benjin.png");
    background-size: 17px 17px;
  }

  .lbo {
    width: 34%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 130px;
    background: #f6f8fc;
    margin-right: 10px;

    .item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      flex: 1;
      position: relative;

      &::after {
        display: block;
        content: "";
        width: 1px;
        height: 40px;
        border: 1px solid #efefef;
        position: absolute;
        right: 0;
      }

      &:nth-last-child(1)::after {
        display: none;
      }

      .htit {
        font-size: 14px;
        font-weight: bold;
        color: #0e2949;
        line-height: 20px;
      }

      .nums {
        font-size: 16px;
        font-weight: bold;
        color: #1d8bfe;
        line-height: 22px;
      }
    }
  }

  .nbo {
    width: 48%;
  }

  .rbo {
    display: flex;
    flex-wrap: nowrap;
    width: 800px;
    background-color: #eef8f8;
    // padding: 10px 10px 0 10px;
    box-sizing: border-box;

    img {
      height: 130px;
      opacity: 0.4;
    }
  }

  .lf {
    flex: 1;
    background: #f6f8fc;
    margin-bottom: 10px;
    height: 250px;
    max-width: 145px;
    overflow: hidden;
    padding: 20px 20px 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .nums {
      font-size: 16px;
      font-weight: 500;
      color: #1d8bfe;
      margin-bottom: 10px;
      line-height: 22px;
    }

    .htit {
      font-size: 14px;
      font-weight: normal;
      color: #0e2949;
      line-height: 20px;
    }
  }

  .rt {
    flex: 3;
    height: 250px;
    background: #f6f8fc;
    display: flex;
    flex-wrap: wrap;
    margin-left: 5px;
    @fraction: 10 / 9;

    .li {
      width: 10% * @fraction;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid #efefef;
      cursor: pointer;

      &:nth-last-child(-n + 9):not(:first-child) {
        /* 样式规则 */
        border: 0 none;
      }

      font-size: 15px;
      font-weight: 500;
      color: #0e2949;
      line-height: 20px;

      .nums {
        margin-top: 5px;
        line-height: 20px;
        font-size: 18px;
        font-weight: 500;
        color: #1d8bfe;
      }
    }

    .cur {
      color: #1d8bfe;
      font-weight: bold;
    }
  }

  .nrt {
    .li {
      width: 12.5%;

      &:nth-last-child(9) {
        /* 样式规则 */
        border-bottom: 1px solid #efefef !important;
      }
    }
  }
}

.botmains {
  background: #fff;

  .tableList {
    padding: 20px;

    .table {
      thead {
        td {
          padding-left: 0;

          &:nth-child(1) {
            padding-left: 20px;
          }
        }
      }

      tbody {
        tr:nth-last-child(1) {
          border-bottom: 1px solid #ebebeb;
        }

        td {
          padding: 6px 0;
          height: 60px;

          &:nth-child(1) {
            padding-left: 20px;
          }

          p {
            padding: 10px 0;
            margin: 0;
            border-bottom: 1px solid #ebebeb;

            &:nth-last-child(1) {
              border: 0 none;
            }
          }
        }
      }
    }
  }
}
</style>
